import { CUTOFF_DAYS_DEFAULT, CUTOFF_DAYS_COVID_VACCINATION } from 'constants/booking'

import { Link } from 'react-router-dom'
import { addDays, format } from 'date-fns'
import { get } from 'lodash'
import T from 'prop-types'
import useSWR from 'swr'
import Joi from 'joi'
import { getAvailability } from 'lib/requests'
import { formatDateClean } from 'lib/date'
import Spinner from 'components/Spinner'
import ErrorMessage from 'components/ErrorMessage'
import Message from 'components/Message'

import Step from '../../components/Step'
import Locations from '../../components/Locations'
import getGenderText from '../../helpers/getGenderText'

export const validator = (values, user_id) =>
  Joi.object({
    location_id: Joi.number().required(),
  }).unknown(true)

export default function Where({ changeStep, values, onChange, orgUnit, bookingType }) {
  const bookingTypeId = get(bookingType, 'id', '')

  // Use a different cutoff time for covid vaccine
  const CUTOFF_DAYS =
    bookingTypeId === 'COVID_VACCINE' ? CUTOFF_DAYS_COVID_VACCINATION : CUTOFF_DAYS_DEFAULT

  // Offset start date to ensure > 6 months between dose 2 and 3
  const dose3BookingOffset =
    bookingTypeId === 'COVID_VACCINE' && values?.allowDose3BookingFromDate
      ? values?.allowDose3BookingFromDate
      : null

  const { data } = useSWR(
    [
      format(dose3BookingOffset ? new Date(dose3BookingOffset) : new Date(), 'yyyy-MM-dd'),
      format(
        addDays(dose3BookingOffset ? new Date(dose3BookingOffset) : new Date(), CUTOFF_DAYS),
        'yyyy-MM-dd',
      ),
      orgUnit.slug,
      bookingTypeId,
    ],
    getAvailability,
  )

  const handleSelect = (id) => {
    onChange('location_id', id)
    changeStep()
  }

  const vaccine = ['FLU_VACCINE', 'COVID_VACCINE'].indexOf(bookingTypeId) !== -1
  const testTitle = getGenderText('Hvor vil %s ta test?', values)
  const vaccineTitle = getGenderText('Hvor vil %s få vaksine?', values)

  return (
    <Step title={vaccine ? vaccineTitle : testTitle}>
      {!data && <Spinner full center box={false} />}
      {data && data.error && <ErrorMessage error={data.error} />}
      {data && data.length === 0 && (
        <Message type="notice">
          Det er ingen ingen tilgjengelige timer eller stasjoner for "{orgUnit.slug}" i perioden fra{' '}
          {formatDateClean(
            dose3BookingOffset ? new Date(dose3BookingOffset) : new Date(),
            'd. MMMM yyyy',
          )}
          .
          <br />
          <br />
          Ta kontakt med ditt vaksinekontor om du mener dette er feil. Du kan også{' '}
          <Link to={`/${orgUnit.slug}/${bookingType?.slug}`}>
            gå tilbake til start og prøve igjen
          </Link>
          .
        </Message>
      )}
      {data && !data.error && <Locations data={data} onSelect={handleSelect} />}
    </Step>
  )
}

Where.propTypes = {
  orgUnit: T.shape({
    id: T.string.isRequired,
    slug: T.string.isRequired,
  }).isRequired,
  bookingType: T.object.isRequired,
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
}
